const baseUrl = '/bills';

/**
 * The billing dashboard lives in the same service as bill extraction but behind a different gateway
 * prefix, so its requests override the client base url with this one.
 */
export const billingDashboardBaseUrl = (process.env.BILL_AUTOMATION_API_ENDPOINT || '').replace(/\/bill-automation\/api\/?$/, '/billing/api');
export const billAutomationBillsRoutes = {
  baseUrl: "".concat(baseUrl),
  billById: billId => "".concat(baseUrl, "/").concat(billId),
  companyBills: companyId => "/companies/".concat(companyId, "/bills"),
  companyBill: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId),
  companyBillsBatch: companyId => "/companies/".concat(companyId, "/bills/batch"),
  billAllocations: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/allocations"),
  allocateBill: (companyId, billId) => "/companies/".concat(companyId, "/bills/").concat(billId, "/allocate")
};